import { render, staticRenderFns } from "./NavDesktopView.vue?vue&type=template&id=1133fdfa&"
import script from "./NavDesktopView.vue?vue&type=script&lang=js&"
export * from "./NavDesktopView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports